module.exports = __webpack_public_path__ + "img/newsimg1.d8d94503.jpg";